import it from './translations/it'
export default it
